import { render, staticRenderFns } from "./PostaKodlari.vue?vue&type=template&id=beb3c348&scoped=true&"
import script from "./PostaKodlari.vue?vue&type=script&lang=js&"
export * from "./PostaKodlari.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beb3c348",
  null
  
)

export default component.exports